// components/business/message-container/components/box/chat-msg-box/chat-msg-box.js
Component({
    /**
     * 组件的属性列表
     */
    properties: {
        msg: {
            type: Object,
            value: {},
            observer: function (msg) {
                let msgContent = msg.content || {};
                if (typeof msgContent == "string") {
                    msgContent = JSON.parse(msgContent || "{}");
                }
                const { text } = msgContent?.display || '';
            
                const data = { msgContent,text };
                
                // console.log(data)
                this.setData(data);
            },
        },
        // 展示所有图片消息集合
        imgUrls: {
            type: Array,
            value: [],
        },
    },

    /**
     * 组件的初始数据
     */
    data: {
        duration: 0,
        feature: {},
        text:''
    },

    /**
     * 组件的方法列表
     */
    methods: {},
});
